import { useState, useRef, useEffect } from "react";

function RadioInput(props : any) {
    const [isActive, setIsActive] = useState(false);
    const inputRef : any = useRef('');    

    // FUNCTION
    const handleChange = (event : any) => {     
        if(props.onChange)
            props.onChange(event);

        setIsActive(event.target.checked);
    }

    return (
        <div className='flex items-center'>
            <input 
                ref={inputRef} 
                onChange={handleChange} 
                defaultChecked = {props.checked || false} 
                className='accent-theme-orange w-[20px] h-[20px]' 
                type="radio" id={props.uniqueID} 
                name = {props.name} 
                value={props.value}
            />
            <label 
                className={`inline-block mx-3 cursor-pointer ${props.labelProperties}`}
                htmlFor={props.uniqueID}> { props.label || '' } 
            </label>
        </div>
    )
}

export default RadioInput